import styled from "styled-components";
import { ChartContainer, SectionTitle } from "../common/Charts.styles";

export const AssessmentsSectionTitle = styled(SectionTitle as any)`
  gap: 0.5rem;
`;

export const AssessmentsChartContainer = styled(ChartContainer as any)`
  flex-direction: row;
  flex-shrink: 1;
  width: 100%;
  max-width: 100%;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 62.5%;
    height: auto;
  }
`;

export const PieChartContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 30%;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 25%;
  }
`;

export const BarChartContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  width: 70%;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 75%;
  }
`;
